import React, { useEffect, useRef, useState } from "react";
import "../styles/components/stepProgress.scss";
import orderPlaced from "../assets/place-order.svg";
import meetDesigner from "../assets/meet-designer.svg";
import procureFabric from "../assets/procure-fabric.svg";
import stitch from "../assets/stitch.svg";
import deliveredOrder from "../assets/delivered.svg";
import chevron from "../assets/double-chevron.svg";

const StepProgress = () => {
  const scrollRef = useRef(null);
  const scrollSpeed = 1; 
  const [isMobile,setIsMobile] = useState(false);

  const steps = [
    {
      image: orderPlaced,
      title: "Place Order",
    },
    {
      image: meetDesigner,
      title: "Meet Your Designer",
    },
    {
      image: procureFabric,
      title: "Pickup/Procure",
    },
    {
      image: stitch,
      title: "Stitch",
    },
    {
      image: deliveredOrder,
      title: "Delivered",
    },
  ];

   useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Auto-scroll for mobile
  useEffect(() => {
    if (!isMobile) return;

    const container = scrollRef.current;
    let animationFrameId;

    const scroll = () => {
      if (!container) return;

      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
      } else {
        container.scrollLeft += scrollSpeed;
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationFrameId);
  }, [isMobile]);

  // Prepare items for rendering
  const displayedSteps = isMobile ? [...steps, ...steps] : steps;

  return (
    <React.Fragment>
      <div className="steps-wrapper" ref={scrollRef}>
        <div class="steps-container">
          {displayedSteps.map((step, index) => (
            <div class="step" key={index}>
              <img src={step.image} alt={step.title} />
              <p>{step.title}</p>
            </div>
          ))}

          <img class="arrow-img arrow1" src={chevron} alt="arrow" />
          <img class="arrow-img arrow2" src={chevron} alt="arrow" />
          <img class="arrow-img arrow3" src={chevron} alt="arrow" />
          <img class="arrow-img arrow4" src={chevron} alt="arrow" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default StepProgress;
